import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

export const supportedLanguages = ['en', 'es'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español'
};

export const languageFlags: Record<SupportedLanguage, string> = {
  en: '🇺🇸',
  es: '🇪🇸'
};

// Route mappings for each language
export const routeMappings: Record<SupportedLanguage, Record<string, string>> = {
  en: {
    pricing: 'pricing',
    'how-it-works': 'how-it-works',
    login: 'login',
    register: 'register',
    terms: 'terms',
    privacy: 'privacy',
    dashboard: 'dashboard',
    onboarding: 'onboarding',
    success: 'success',
    admin: 'admin',
    'reset-password': 'reset-password'
  },
  es: {
    pricing: 'precios',
    'how-it-works': 'como-funciona',
    login: 'iniciar-sesion',
    register: 'registrarse',
    terms: 'terminos',
    privacy: 'privacidad',
    dashboard: 'panel',
    onboarding: 'incorporacion',
    success: 'exito',
    admin: 'admin',
    'reset-password': 'restablecer-contrasena'
  }
};

// Reverse mapping to find the internal route from localized path
export const getInternalRoute = (lang: SupportedLanguage, localizedPath: string): string => {
  const mapping = routeMappings[lang];
  const entry = Object.entries(mapping).find(([, value]) => value === localizedPath);
  return entry ? entry[0] : localizedPath;
};

// Get localized path from internal route
export const getLocalizedPath = (lang: SupportedLanguage, internalRoute: string): string => {
  return routeMappings[lang][internalRoute] || internalRoute;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    }
  });

export default i18n;
